module.exports = __webpack_public_path__ + "static/kartgames-1c9f93b972a0956e0c052abafe0968cc.mp4";